import * as CookieConsent from "vanilla-cookieconsent";

window.addEventListener("load", function () {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	 */
	CookieConsent.run({

		// root: 'body',
		// autoShow: true,
		// disablePageInteraction: true,
		// hideFromBots: true,
		// mode: 'opt-in',
		// revision: 0,

		cookie: {
			name: 'evidentist_cookies',
			// domain: location.hostname,
			// path: '/',
			// sameSite: "Lax",
			// expiresAfterDays: 365,
		},

		// https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
		guiOptions: {
			consentModal: {
				layout: 'box',
				position: 'bottom right',
				equalWeightButtons: true,
				flipButtons: false
			},
			preferencesModal: {
				layout: 'box',
				equalWeightButtons: true,
				flipButtons: false
			}
		},

		// onFirstConsent: ({cookie}) => {
		// 	console.log('onFirstConsent fired',cookie);
		// },
		//
		onConsent: ({cookie}) => {
			updateGtagConsent();
		},
		//
		onChange: ({changedCategories, changedServices}) => {
			updateGtagConsent();
		},
		//
		// onModalReady: ({modalName}) => {
		// 	console.log('ready:', modalName);
		// },
		//
		// onModalShow: ({modalName}) => {
		// 	console.log('visible:', modalName);
		// },
		//
		// onModalHide: ({modalName}) => {
		// 	console.log('hidden:', modalName);
		// },

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			analytics: {},
		},

		language: {
			default: document.documentElement.getAttribute("lang"),
			translations: {
				cs: {
					consentModal: {
						title: "Používáme cookies!",
						description: "Tyto webové stránky používají nezbytné soubory cookies k zajištění svého správného fungování a sledovací (tj. výkonnostní/analytické) soubory cookies k pochopení toho, jak se stránkami pracujete. Ty se ukládají pouze po Vašem souhlasu.",
						acceptAllBtn: 'Přijmout',
						acceptNecessaryBtn: 'Odmítnout',
						showPreferencesBtn: 'Nastavení',
						// closeIconLabel: 'Reject all and close modal',
						// footer: `
                        //     <a href="#path-to-impressum.html" target="_blank">Impressum</a>
                        //     <a href="#path-to-privacy-policy.html" target="_blank">Privacy Policy</a>
                        // `,
					},
					preferencesModal: {
						title: 'Nastavení cookies',
						acceptAllBtn: 'Přijmout vše',
						acceptNecessaryBtn: 'Odmítnout vše',
						savePreferencesBtn: 'Uložit nastavení',
						closeIconLabel: 'Zavřít',
						serviceCounterLabel: 'Služba|Služby',
						sections: [
							{
								title: 'Používání cookies',
								description: `Soubory cookies používáme k zajištění základních funkcí webových stránek a ke zlepšení vašeho online zážitku. U jednotlivých kategorií (s výjimkou nezbytných cookies) si můžete kdykoliv zvolit, zda souhlasíte s používáním cookies.`,
							},
							{
								title: 'Nezbytně nutné soubory cookies',
								description: 'Tyto soubory cookies jsou nezbytné pro správné fungování našich webových stránek. Bez těchto souborů cookies by webové stránky nefungovaly správně.',

								//this field will generate a toggle linked to the 'necessary' category
								linkedCategory: 'necessary'
							},
							{
								title: 'Výkonnostní a analytické cookies',
								description: 'Tyto soubory cookies umožňují webové stránce rozpoznat a určit počet návštěvníků, zapamatovat si Vaše volby a jakým způsobem stránky používáte.',
								linkedCategory: 'analytics',
								cookieTable: {
									caption: 'Přehled cookies',
									headers: {
										name: 'Cookie',
										domain: 'Doména',
										desc: 'Popis'
									},
									body: [
										{
											name: "^_ga",
											domain: "google.com",
											desc: "Cookie služby Google Analytics.",
										},
										{
											name: '_gid',
											domain: "google.com",
											desc: 'Cookie služby Google Tag Manager 2',
										},
										{
											name: '__sp_id.1fff',
											domain: "ecomail.cz",
											desc: 'Cookie služby Ecomail',
										},
										{
											name: '_sp_ses.1fff',
											domain: "ecomail.cz",
											desc: 'Cookie služby Ecomail',
										},
									]
								}
							},
							{
								title: 'Více informací',
								description: "V případě jakýchkoli dotazů týkajících se našich zásad ohledně souborů cookie a vašich voleb nás prosím <a class='cc-link' href='https://www.evidentist.cz/kontakty'>kontaktujte</a>.",
							}
						]
					}
				},
				en: {
					consentModal: {
						title: 'We use cookies',
						description: 'These websites use essential cookies to ensure their proper functioning and tracking (i.e., performance/analytics) cookies to understand how you interact with the pages. They are stored only with your consent.',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Manage Individual preferences',
						// closeIconLabel: 'Reject all and close modal',
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						serviceCounterLabel: 'Service|Services',
						sections: [
							{
								title: 'The use of cookies',
								description: `We use the cookies to ensure the essential functions of our website and to improve your browsing experience. You can select which cookies you agree to use (with the exception of essential cookies).`,
							},
							{
								title: 'Essential cookies',
								description: 'These cookies are essential for the functioning of our website. Without these the website would not work.',

								//this field will generate a toggle linked to the 'necessary' category
								linkedCategory: 'necessary'
							},
							{
								title: 'Performance and analytical cookies',
								description: 'These cookies enable the website to recognize the amounts of visitors and remember your choices of how you use the website functions.',
								linkedCategory: 'analytics',
								cookieTable: {
									caption: 'Cookie table',
									headers: {
										name: 'Cookie',
										domain: 'Domain',
										desc: 'Description'
									},
									body: [
										{
											name: '^_ga',
											domain: 'google.com',
											desc: 'Google Analytics Cookie',
										},
										{
											name: '_gid',
											domain: 'google.com',
											desc: 'Google Tag Manager Cookie',
										},
										{
											name: '__sp_id.1fff',
											domain: "ecomail.cz",
											desc: 'Ecomail cookie',
										},
										{
											name: '_sp_ses.1fff',
											domain: "ecomail.cz",
											desc: 'Ecomail cookie',
										},
									]
								}
							},
							{
								title: 'Targeting and Advertising',
								description: 'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
								linkedCategory: 'ads',
							},
							{
								title: 'More information',
								description: `In case you have a question about our cookie policy, please <a class='cc-link' href='https://www.evidentist.cz/en/contact'>contact us</a>.`
							}
						]
					}
				}
			}
		}
	});

});

function updateGtagConsent() {
	gtag('consent', 'update', {
		'ad_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
		'ad_user_data': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
		'ad_personalization': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
		'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
		'functionality_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
		'personalization_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
	});

	dataLayer.push({ event: 'consent_update' });
}
